export const legalEntitiesRoutes = [
  {
    path: '/legal-entities',
    name: 'legalEntities',
    redirect: '/legal-entities/',
    meta: {
      locationTypes: ['organization', 'singleLocation'],
      permissions: ['organizationManagementAccess']
    },
    children: [
      {
        path: '',
        name: 'legalEntitiesList',
        component: () => import('@/modules/legal-entity/views/LegalEntities.vue'),
        meta: {
          locationTypes: ['organization', 'singleLocation'],
          permissions: ['organizationManagementAccess']
        }
      },
      {
        name: 'legalEntity',
        path: ':legalEntityId',
        component: () => import('@/modules/legal-entity/views/LegalEntity.vue'),
        meta: {
          locationTypes: ['organization', 'singleLocation', 'location'],
          permissions: ['organizationManagementAccess']
        }
      }
    ]
  }
]
